import React, { useEffect } from 'react';

import { Modal, ModalBody } from 'reactstrap';
import strings from '../../../lang/strings';
import { observer } from 'mobx-react';
import { formatNumber } from '../../../helper/common'

const BuyOptionsModal = observer((props) => {
    const { show, toggle } = props;

    const select = (option) => {
        toggle();
        props.cb?.(option)
    }

    return (
        <Modal isOpen={show} toggle={() => toggle()} className='modal-point-pay'>
            <ModalBody>
                <div className='modal-header-custom d-center position-relative'>
                    <div className='fs-20 sm-fs-18 f-b'>{strings.bo_title}</div>
                    <div className='modal-close-btn d-center position-absolute' onClick={() => toggle()}>
                        <img src={'/assets/image/close.png'} alt='' className='modal-close' />
                    </div>
                </div>
                <div className='modal-buy-option-container'>
                    <div className='modal-buy-option text-left' onClick={() => select('normal')}>
                        <div className='title-area mb-8'>
                            <div className='fs-20 sm-fs-14 f-b '>{`${strings.dat_normal} ${strings.dat_buy}`}</div>
                            <div className='fs-16 sm-fs-16 f-b'>{formatNumber(props.price1) + strings._p}</div>
                        </div>
                        <div className='desc-area fs-14 sm-fs-12 f-m ml-20 space-break'>{strings.dat_normal_desc}</div>
                    </div>
                    <div className='modal-buy-option text-left' onClick={() => select('new')}>
                        <div className='title-area mb-8'>
                            <div className='fs-20 sm-fs-14 f-b '>{`${strings.dat_special} ${strings.dat_buy}`}</div>
                            <div className='fs-16 sm-fs-16 f-b'>{formatNumber(props.price2) + strings._p}</div>
                        </div>
                        <div className='desc-area fs-14 sm-fs-12 f-m ml-20 space-break'>{strings.dat_special_desc}</div>
                        <div className='color-e45a5a fs-12 ml-20 f-b'>{strings.refund_msg}</div>
                    </div>
                </div>

            </ModalBody>
        </Modal>
    );
});

export default BuyOptionsModal;
